import { Component, OnInit } from '@angular/core';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { MonthEndReport } from 'src/app/models/industry-reports.model';
import { TableColumn } from 'src/app/models/table-columns';
import { IndustryReportsService } from 'src/app/services/industry-reports.service';

@Component({
  selector: 'app-month-end-report',
  templateUrl: './month-end-report.component.html',
  styleUrls: ['./month-end-report.component.scss']
})
export class MonthEndReportComponent extends ScrBaseComponent implements OnInit {

  monthEndReports: MonthEndReport[] = [];
  tableColumn: TableColumn[] = [
    { field: 'startDate', width: '5' },
    { field: 'fraudCount',  width: '5' },
    { field: 'unsolicitedMessageCount',  width: '6' },
    { field: 'total', width: '5' },
    { field: 'passCount', width: '5' },
    { field: 'severity0Count', width: '5' },
    { field: 'severity1Count', width: '5' },
    { field: 'severity2Count', width: '5' }
  ];
  constructor(private industryReportsService: IndustryReportsService) {
    super();
  }

  ngOnInit(): void {
    this.localizeTableColumns(this.tableColumn);
    this.retrieveReports();
  }

  retrieveReports() {
    this.observe(this.industryReportsService.getMonthEndReports(), res => {
      this.monthEndReports = res.data;
      return false;
    });
  }

  downloadReport(report: MonthEndReport) {
    this.observeDownloadOrAny(this.industryReportsService.downloadMonthEndReport(report.startDate), res => {
      this.industryReportsService.processBlobResponseDownload(res, 'application/pdf');
    });
  }

}
